import type {ICustomFormItemRaw} from '../types';

export const getCustomFormRawFromJson = (customFormJson: string) => {
	return JSON.parse(
		customFormJson.replace(/\\\"/g, '"'),
	) as ICustomFormItemRaw[];
};
